import { api } from "services/api"
import ErrorHandler from "./ErrorHandler"
import { formatMetricsDate } from "utils/formatDate"

export interface MetricsPayload extends App.MetricsParams {
  skip: number
  take: number
}

class ApiMetrics extends ErrorHandler {
  public async searchProductsMetrics(params: MetricsPayload) {
    const payload = formatMetricsDate(params)

    if (!payload.dateStart || !payload.dateEnd) return

    return api.get("/metrics/products", {
      params: payload
    })
  }

  public async searchMetricsCharts(params: App.MetricsParams) {
    const payload = formatMetricsDate(params)

    if (!payload.dateStart || !payload.dateEnd) return

    return api.get("/metrics/charts", {
      params: payload
    })
  }

  public async searchMetricsCards(params: App.MetricsParams) {
    const payload = formatMetricsDate(params)

    if (!payload.dateStart || !payload.dateEnd) return

    return api.get("/metrics/cards", {
      params: payload
    })
  }
}

export default ApiMetrics
